import { ORDER_STATUS } from '../enums';

export * from './roles.constant';
export * from './states.constant';
export * from './status.constant';
export * from './addressType.constant';
export * from './mock.constant';
export * from './gender.constant';
export * from './languages.constant';
export * from './filters.constant';
export * from './tripStatus.constant';
export const REGEX_PHONE = /^([0-9]{3})[-]?([0-9]{3})[-]?([0-9]{4})$/;
export const REGEX_URL = new RegExp('^(https?:\\/\\/)?' +
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
  '((\\d{1,3}\\.){3}\\d{1,3}))' +
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
  '(\\?[;&a-z\\d%_.~+=-]*)?' +
  '(\\#[-a-z\\d_]*)?$', 'i');
export const PATH_ORDERS_TAB = {
  NEW_LOADS: 'new-loads',
  ASSIGNED: 'assigned',
  DECLINED: 'declined',
  PICKED_UP: 'picked-up',
  DELIVERED: 'delivered',
  CLAIMED: 'claimed',
  BILLED: 'billed',
  PAID: 'paid',
  PAST_DUE: 'past-due',
  ARCHIVED: 'archived',
};

export const CUSTOM_ORDER_PATHS = {
  REPORTED: '/reported',
};

export const COMPANY_STATUSES = {
  ACTIVE: 'active',
  REQUESTED: 'requested',
};

export const MESSAGES = {
  'requested-changes': 'Wait for the admin confirmation',
  default: 'Default',
};

export const TABS_ACTIVATED = {
  totalDue: 6,
  totalPaid: 8,
  pastDue: 6,
};

export const MAP_LAYERS = ['https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}'];

export const WEB_NOTIFICATION = {
  ORDER: 'order',
  LEAD: 'lead',
  USER: 'user',
  QUOTE: 'quote',
  QUOTE_CREATED: 'quote_created',
  TRIP: 'trip',
  CARRIER: 'carrier',
  LOADBORD: 'loadbord',
  LOCATION: 'location',
};

export const enum WEB_NOTIFICATION_TYPES {
  NEW_JOIN_REQUEST = 'new_join_request',
  DRIVER_LEFT_YOUR_FLEET = 'driver_left_your_fleet',
  ORDER_WAS_DECLINED_BY_DRIVER = 'order_was_declined_by_driver',
  ORDER_WAS_DECLINED_BY_CLIENT = 'order_was_declined_by_client',
  QUOTE_WAS_CREATED = 'quote_was_created',
}

export const CLIENT_PAYMENT_STATUSES = {
  NONE: 'none',
  SERVICE_FEE_FAILED: 'service_fee_failed',
  SERVICE_FEE_PAID: 'service_fee_paid',
  SERVICE_FEE_UNPAID: 'service_fee_unpaid',
  CAR_PICKUP_FAILED: 'car_pickup_failed',
  CAR_PICKUP_PAID: 'car_pickup_paid',
};

export const ORDER_PAYMENT_STATUSES = {
  NONE: 'none',
  PAID: 'paid'
};

export const INVITE_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  DECLINED: 3,
  EXPIRED: 4,
}

export const SEND_BOL_STATUSES = [
  ORDER_STATUS.PICKED_UP.toString(),
  ORDER_STATUS.ON_DELIVERY.toString(),
  ORDER_STATUS.ON_WAY_TO_DELIVERY.toString(),
  ORDER_STATUS.DELIVERED.toString(),
  ORDER_STATUS.CLAIMED.toString(),
  ORDER_STATUS.BILLED.toString()
];
